import {createContext, type FC, useContext, useState} from 'react';

export interface OnboardingContextData {
  isMoreMenuOpen?: boolean;
  isPlanMenuOpen?: boolean;
  isLeftDrawerOpen?: boolean;
  isFirstSiteOpen?: boolean;
  enabled: boolean;
}

const OnboardingContext = createContext<OnboardingContextData>({enabled: false});
export const useOnboardingContext = () => useContext(OnboardingContext);

export const OnboardingContextProvider: FC<any> = ({children}) => {
  const [state, setState] = useState<OnboardingContextData>({enabled: false});

  const proxyHandler = {
    set(target: OnboardingContextData, prop: keyof OnboardingContextData, value: any) {
      const newState: OnboardingContextData = {...state, [prop]: value, enabled: prop === 'enabled' ? value : true};
      setState(newState);
      return true;
    },
    get(target: OnboardingContextData, prop: keyof OnboardingContextData) {
      if (!state.enabled) {
        return undefined;
      }
      return state[prop];
    },
  };

  const value = new Proxy(state, proxyHandler);

  return <OnboardingContext.Provider value={value}>{children}</OnboardingContext.Provider>;
};
